import { render, staticRenderFns } from "./DetailsVideoForm.vue?vue&type=template&id=0311f421&scoped=true"
import script from "./DetailsVideoForm.vue?vue&type=script&lang=js"
export * from "./DetailsVideoForm.vue?vue&type=script&lang=js"
import style0 from "./DetailsVideoForm.vue?vue&type=style&index=0&id=0311f421&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311f421",
  null
  
)

export default component.exports